import React, { Fragment } from "react";
import { classNames } from "../../helpers/classNames";

const Radio = ({
  onChange = () => {},
  value,
  mainClasses,
  radioName,
  radioInputClass,
  isChecked,
  radioLabel,
  radioLableClass,
  divClass,
  checked,
  errorText,
  errorType,
  disabled,
  ...props
}) => {
  return (
    <Fragment>
      <label>
        <div
          className={classNames(
            "relative overflow-hidden flex items-center",
            mainClasses
          )}
        >
          <input
            type="radio"
            name={radioName}
            className={classNames(
              "peer absolute top-0 left-0 w-full h-full opacity-0 z-10 cursor-pointer",
              radioInputClass
            )}
            defaultChecked={isChecked}
            checked={checked}
            onChange={onChange}
            value={value}
            disabled={disabled}
          />
          <div
            className={classNames(
              "w-5 h-5 min-w-[20px] mr-3 border border-slate-300 rounded-full flex items-center justify-center text-[10px] bg-white text-black/0 peer-checked:border-gray-200 peer-checked:text-deep-purple peer-checked:bg-primary",
              divClass
            )}
          >
            <i
              className={classNames(
                "fa-fw fa-circle text-white", // text-white for contrast
                checked ? "fa-solid" : "fa-regular"
              )}
            ></i>
          </div>
          <div
            className={classNames(
              "text-sm text-slate-500 w-full",
              radioLableClass
            )}
          >
            {radioLabel}
          </div>
        </div>
      </label>
      {errorType && errorType === "error" && (
        <div className="text-xs text-red-600 mt-1">
          <i className="fa-regular fa-fw fa-square-exclamation text-sm mr-1"></i>
          {errorText}
        </div>
      )}
      {errorType && errorType === "warning" && (
        <div className="text-xs text-amber-500 mt-1">
          <i className="fa-regular fa-fw fa-triangle-exclamation text-sm mr-1"></i>
          {errorText}
        </div>
      )}
      {errorType && errorType === "success" && (
        <div className="text-xs text-green-600 mt-1">
          <i className="fa-regular fa-fw fa-circle-check text-sm mr-1"></i>
          {errorText}
        </div>
      )}
      {errorType && errorType === "info" && (
        <div className="text-xs text-sky-600 mt-1">
          <i className="fa-regular fa-fw fa-circle-info text-sm mr-1"></i>
          {errorText}
        </div>
      )}
    </Fragment>
  );
};

export default Radio;
